import { inject, injectable } from "inversify";
import System from "../system/System";
import SERVICE_IDENTIFIER from "../constants/identifiers";
import events from "../events/EventsObservable";
import SystemConfig, {
	buildParagraphUrl,
	CONFIG_PARAMS,
} from "../system/SystemConfig";
import BaseDOM from "../ui/BaseDOM";
import { ACTION_EVENTS } from "../ui/UserAction";
import AbstractIframePage from "./AbstractIfarmePage";
import { STATES } from "../states/states";

@injectable()
export default class IframeParagraphPage extends AbstractIframePage {
	protected appName: string = "pages";
	protected previousState: string | undefined = undefined;

	constructor(
		@inject(SERVICE_IDENTIFIER.SystemConfig) config: SystemConfig,
		@inject(SERVICE_IDENTIFIER.DOM) DOM: BaseDOM,
		@inject(SERVICE_IDENTIFIER.System) system: System
		// @inject(SERVICE_IDENTIFIER.UIStates) protected states: AbstractStates
	) {
		super(config, DOM, system);
		events.subscribe(ACTION_EVENTS.ACTION_PARAGRAPH_CLOSE, () => this.close());
		events.subscribe(ACTION_EVENTS.ACTION_PARAGRAPH_OPEN, () => this.open());
	}

	create(): void {
		if (this.created) return;
		super.create();
		this.iframe.setSrc(
			buildParagraphUrl(
				this.config.get(CONFIG_PARAMS.IS_PARAGRAPH),
				this.config,
				{ type: "legal" }
			)
		);
		this.iframe.setCloseAction(ACTION_EVENTS.ACTION_PARAGRAPH_CLOSE);
	}

	open(): Promise<boolean> {
		// this.previousState = this.states.getState()
		// this.states.setState(STATES.PARAGRAPH)
		return super.open();
	}

	close(): Promise<boolean> {
		// if (this.previousState !== undefined) {
		// 	this.states.setState(this.previousState)
		// } else {
		// 	this.states.setState(STATES.IDLE)
		// }
		return super.close();
	}
}
